export var numberToPixel = function(value) {
    return value ? "".concat(value, "px") : undefined;
};
